import {
    // AppBar, CardActions, Toolbar,
    // Button,
    Grid,
} from '@mui/material';
import {
    Autocomplete,
    // Avatar, Divider,
    Paper,
    TextField,
    // Tooltip,
} from '@mui/material';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
// import AddCircleIcon from "@mui/icons-material/AddCircle";
import moment from 'moment';
import PropTypes from 'prop-types';
import * as React from 'react';
import { useEffect,useState } from 'react';
import Board from 'react-trello';

import { fetchMissionExperts } from '../../Api/suiviMission/experts';
import { fetchStatusTasks, updateTask } from '../../Api/suiviMission/tasks';
import Cal from '../../Components/suiviMission/Cal';
import HeaderBar from '../../Components/suiviMission/HeaderBar';
import AddTaskModal from '../../Components/suiviMission/modals/AddTaskModal';
import TasksList from '../../Components/suiviMission/TasksList';
import { useGlobalContext } from '../../Contexts/suiviMission/GlobalContext';
import { useTaskContext } from '../../Contexts/suiviMission/TaskContext';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function Tasks() {
    const { mission } = useGlobalContext();
    const [value, setValue] = useState(0);
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [todocards, settodocards] = useState([]);
    const [incards, setincards] = useState([]);
    const [doneCards, setdoneCards] = useState([]);
    useEffect(() => {
        if (!mission._id) return;
        console.log(`mission value : ${mission._id}`);
        fetchStatusTasks(settodocards, mission._id, 'to do');
        fetchStatusTasks(setincards, mission._id, 'in progress');
        fetchStatusTasks(setdoneCards, mission._id, 'done');
        console.log(mission._id);
    }, [mission]);
    // useEffect(() => {
    //   console.log(`data2 value : ${data2}`, setData2);
    // }, [data2]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const { tasks, setTasks } = useTaskContext();

    const cardsTodo = todocards.map((task) => {
        console.count(task);
        console.log(task);
        return {
            title: task?.title,
            id: task._id,
            priority: task.priority,
            label:
				moment(task.dateFin).valueOf() < moment().valueOf() ? 'En retard' : '',
            responsable: task.expertId.map((ex) => {
                return ex.persoData.nom;
            }),
            overdue:
				moment(task.dateFin).valueOf() < moment().valueOf() ? true : false,
            tags: [
                {
                    bgcolor:
						task.priority === 'high'
						    ? '#F50000'
						    : task.priority === 'medium'
						        ? '#FFCF00'
						        : task.priority === 'low'
						            ? '#00F500'
						            : '#00F500',
                    color: 'white',
                    title: task.priority,
                },
                {
                    title: task.expertId[0]
                        ? task.expertId[0]?.persoData?.nom
                        : 'none',
                    style: {
                        borderRadius: '5rem',
                        backgroundColor: '#1976D2',
                        width: 'fit-content',
                        height: 'fit-content',
                        padding: '4px',
                        color: '#FFFFFF',
                        fontWeight: 'bold',
                    },
                },
            ],
        };
    });
    const cardsInprogress = incards.map((task) => {
        return {
            title: task.title,
            id: task._id,
            priority: task.priority,
            label:
				moment(task.dateFin).valueOf() < moment().valueOf() ? 'En retard' : '',
            responsable: task.expertId.map((ex) => {
                return ex.persoData?.nom;
            }),
            overdue:
				moment(task.dateFin).valueOf() < moment().valueOf() ? true : false,
            tags: [
                {
                    bgcolor:
						task.priority === 'high'
						    ? '#F50000'
						    : task.priority === 'medium'
						        ? '#FFCF00'
						        : task.priority === 'low'
						            ? '#00F500'
						            : '#00F500',
                    color: 'white',
                    title: task.priority,
                },
                {
                    title: task.expertId[0]
                        ? task.expertId[0]?.persoData?.nom
                        : 'none',
                    style: {
                        borderRadius: '5rem',
                        backgroundColor: '#1976D2',
                        width: 'fit-content',
                        height: 'fit-content',
                        padding: '4px',
                        color: '#FFFFFF',
                        fontWeight: 'bold',
                    },
                },
            ],
        };
    });
    const cardsDone = doneCards.map((task) => {
        return {
            title: task.title,
            id: task._id,
            priority: task.priority,
            label:
				moment(task.dateFin).valueOf() < moment().valueOf() ? 'En retard' : '',
            responsable: task.expertId.map((ex) => {
                return ex?.persoData?.nom;
            }),
            overdue:
				moment(task.dateFin).valueOf() < moment().valueOf() ? true : false,
            tags: [
                {
                    bgcolor:
						task.priority === 'high'
						    ? '#F50000'
						    : task.priority === 'medium'
						        ? '#FFCF00'
						        : task.priority === 'low'
						            ? '#00F500'
						            : '#00F500',
                    color: 'white',
                    title: task.priority,
                },
                {
                    title: task.expertId[0]
                        ? task.expertId[0]?.persoData?.nom
                        : 'none',
                    style: {
                        borderRadius: '5rem',
                        backgroundColor: '#1976D2',
                        width: 'fit-content',
                        height: 'fit-content',
                        padding: '4px',
                        color: '#FFFFFF',
                        fontWeight: 'bold',
                    },
                },
            ],
        };
    });

    const data = {
        lanes: [
            {
                id: 'lane1',
                title: 'To do',
                status: 'to do',
                label: '0/2',

                cards: cardsTodo,
            },
            {
                id: 'lane2',
                title: 'In progress',
                label: '1/2',
                status: 'in progress',
                cards: cardsInprogress,
            },
            {
                id: 'lane3',
                title: 'Done ',
                status: 'done',
                label: '2/2',
                cards: cardsDone,
            },
        ],
    };

    // Meriem Data
    const data2 = {
        'lanes': [
            {
                'id': 'lane1',
                'title': 'To do',
                'status': 'to do',
                'label': '0/2',
                'cards': [
                    {
                        'title': 'kkk',
                        'id': '630f330fbef51a58a46c1671',
                        'priority': 'medium',
                        'label': 'En retard',
                        'responsable': [
                            'djnj'
                        ],
                        'overdue': true,
                        'tags': [
                            {
                                'bgcolor': '#FFCF00',
                                'color': 'white',
                                'title': 'medium'
                            },
                            {
                                'title': 'djnj',
                                'style': {
                                    'borderRadius': '5rem',
                                    'backgroundColor': '#1976D2',
                                    'width': 'fit-content',
                                    'height': 'fit-content',
                                    'padding': '4px',
                                    'color': '#FFFFFF',
                                    'fontWeight': 'bold'
                                }
                            }
                        ]
                    }
                ]
            },
            {
                'id': 'lane2',
                'title': 'In progress',
                'label': '1/2',
                'status': 'in progress',
                'cards': [
                    {
                        'title': 'ttt',
                        'id': '630f34c7bef51a58a46c16ed',
                        'priority': 'medium',
                        'label': 'En retard',
                        'responsable': [],
                        'overdue': true,
                        'tags': [
                            {
                                'bgcolor': '#FFCF00',
                                'color': 'white',
                                'title': 'medium'
                            },
                            {
                                'title': 'none',
                                'style': {
                                    'borderRadius': '5rem',
                                    'backgroundColor': '#1976D2',
                                    'width': 'fit-content',
                                    'height': 'fit-content',
                                    'padding': '4px',
                                    'color': '#FFFFFF',
                                    'fontWeight': 'bold'
                                }
                            }
                        ]
                    },
                    {
                        'title': 'task',
                        'id': '630513d7d735af62e820991c',
                        'priority': 'medium',
                        'label': 'En retard',
                        'responsable': [
                            'djnj'
                        ],
                        'overdue': true,
                        'tags': [
                            {
                                'bgcolor': '#FFCF00',
                                'color': 'white',
                                'title': 'medium'
                            },
                            {
                                'title': 'djnj',
                                'style': {
                                    'borderRadius': '5rem',
                                    'backgroundColor': '#1976D2',
                                    'width': 'fit-content',
                                    'height': 'fit-content',
                                    'padding': '4px',
                                    'color': '#FFFFFF',
                                    'fontWeight': 'bold'
                                }
                            }
                        ]
                    },
                    {
                        'title': 'another rask',
                        'id': '630510a2a10f16e974e162e5',
                        'priority': 'medium',
                        'label': '',
                        'responsable': [],
                        'overdue': false,
                        'tags': [
                            {
                                'bgcolor': '#FFCF00',
                                'color': 'white',
                                'title': 'medium'
                            },
                            {
                                'title': 'none',
                                'style': {
                                    'borderRadius': '5rem',
                                    'backgroundColor': '#1976D2',
                                    'width': 'fit-content',
                                    'height': 'fit-content',
                                    'padding': '4px',
                                    'color': '#FFFFFF',
                                    'fontWeight': 'bold'
                                }
                            }
                        ]
                    }
                ]
            },
            {
                'id': 'lane3',
                'title': 'Done ',
                'status': 'done',
                'label': '2/2',
                'cards': [
                    {
                        'title': 'new taskkk',
                        'id': '630f3e2ebef51a58a46c1afd',
                        'priority': 'medium',
                        'label': 'En retard',
                        'responsable': [
                            'djnj'
                        ],
                        'overdue': true,
                        'tags': [
                            {
                                'bgcolor': '#FFCF00',
                                'color': 'white',
                                'title': 'medium'
                            },
                            {
                                'title': 'djnj',
                                'style': {
                                    'borderRadius': '5rem',
                                    'backgroundColor': '#1976D2',
                                    'width': 'fit-content',
                                    'height': 'fit-content',
                                    'padding': '4px',
                                    'color': '#FFFFFF',
                                    'fontWeight': 'bold'
                                }
                            }
                        ]
                    },
                    {
                        'title': 'td',
                        'id': '630f2f77bef51a58a46c15f3',
                        'priority': 'medium',
                        'label': 'En retard',
                        'responsable': [
                            'djnj'
                        ],
                        'overdue': true,
                        'tags': [
                            {
                                'bgcolor': '#FFCF00',
                                'color': 'white',
                                'title': 'medium'
                            },
                            {
                                'title': 'djnj',
                                'style': {
                                    'borderRadius': '5rem',
                                    'backgroundColor': '#1976D2',
                                    'width': 'fit-content',
                                    'height': 'fit-content',
                                    'padding': '4px',
                                    'color': '#FFFFFF',
                                    'fontWeight': 'bold'
                                }
                            }
                        ]
                    },
                    {
                        'title': 'task 1',
                        'id': '6305043aa10f16e974e0a0af',
                        'priority': 'medium',
                        'label': 'En retard',
                        'responsable': [
                            'djnj'
                        ],
                        'overdue': true,
                        'tags': [
                            {
                                'bgcolor': '#FFCF00',
                                'color': 'white',
                                'title': 'medium'
                            },
                            {
                                'title': 'djnj',
                                'style': {
                                    'borderRadius': '5rem',
                                    'backgroundColor': '#1976D2',
                                    'width': 'fit-content',
                                    'height': 'fit-content',
                                    'padding': '4px',
                                    'color': '#FFFFFF',
                                    'fontWeight': 'bold'
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    };

    // Docs Data
    const data3 = {
        lanes: [
            {
                id: 'lane1',
                title: 'Planned Tasks',
                label: '2/2',
                cards: [
                    { id: 'Card1', title: 'Write Blog', description: 'Can AI make memes', label: '30 mins', draggable: false },
                    { id: 'Card2', title: 'Pay Rent', description: 'Transfer via NEFT', label: '5 mins', metadata: { sha: 'be312a1' } }
                ]
            },
            {
                id: 'lane2',
                title: 'Completed',
                label: '0/0',
                cards: []
            }
        ]
    };

    const handleMoveCardAcrossLane = (fromLaneId, toLaneId, cardId, index) => {
        console.log('handle card move');
        console.log(fromLaneId);
        console.log(toLaneId);
        console.log(cardId);
        console.log(index);
        const newStatus = () => {
            return data.lanes.find((l) => l.id === toLaneId).status;
        };
        const oldStatus = () => {
            return data.lanes.find((l) => l.id === fromLaneId).status;
        };
        var task = undefined;

        switch (oldStatus()) {
        case 'to do':
            task = tasks.find((t) => t._id === cardId);
            if (task) {
                settodocards((current) =>
                    current.filter((element) => {
                        return element._id !== task._id;
                    })
                );
            }
            break;
        case 'in progress':
            task = tasks.find((t) => t._id === cardId);
            if (task) {
                setincards((current) =>
                    current.filter((element) => {
                        return element._id !== task._id;
                    })
                );
            }
            break;
        case 'done':
            task = tasks.find((t) => t._id === cardId);
            if (task) {
                setdoneCards((current) =>
                    current.filter((element) => {
                        return element._id !== task._id;
                    })
                );
            }
            break;

        default:
            break;
        }
        switch (newStatus()) {
        case 'to do':
            settodocards((o) => [...o, task]);
            break;
        case 'in progress':
            setincards((o) => [...o, task]);
            break;
        case 'done':
            setdoneCards((o) => [...o, task]);
            break;

        default:
            break;
        }
        const updates = {
            status: newStatus(),
        };

        updateTask(cardId, updates);

        // replace task status
        let newArr = [...tasks];
        newArr.find((l) => l._id === cardId).status = newStatus();
        setTasks(newArr);
    };

    // const myCard = ({ title, tags, id, priority, overdue, responsable }) => {
    //   return (
    //     <Paper sx={{ padding: "0px", margin: "10px" }}>
    //       <Grid container justifyContent="start" alignItems="baseline">
    //         {/* {title}
    //       {id}
    //       {tags[0].title} */}
    //         <Grid item xs={12}>
    //           <Typography align="left" sx={{ fontSize: 13, marginLeft: "3px" }}>
    //             {title}
    //           </Typography>
    //         </Grid>
    //         <Grid item xs={12}>
    //           {overdue && (
    //             <div
    //               style={{
    //                 padding: "2px",
    //                 backgroundColor: "#F50000",
    //                 width: "fit-content",
    //                 borderRadius: "3px",
    //                 marginLeft: "10px",
    //                 color: "#FFFFFF",
    //                 fontSize: "12px",
    //               }}
    //             >
    //               En retard
    //             </div>
    //           )}
    //           <Divider sx={{ borderBottom: "block 12px" }} />
    //         </Grid>

    //         <Grid item xs={12}>
    //           <div
    //             style={{
    //               padding: "2px",
    //               backgroundColor:
    //                 priority === "high"
    //                   ? "#F50000"
    //                   : priority === "medium"
    //                   ? "#FFCF00"
    //                   : priority === "low"
    //                   ? "#00F500"
    //                   : "#00F500",
    //               width: "fit-content",
    //               borderRadius: "3px",
    //               marginLeft: "10px",
    //               color: "#FFFFFF",
    //               fontSize: "12px",
    //             }}
    //           >
    //             {priority}
    //           </div>
    //           <Avatar
    //             sx={{ width: 30, height: 30 }}
    //             style={{ backgroundColor: "#5778FF" }}
    //           >
    //             {responsable[0][0]}
    //           </Avatar>
    //         </Grid>
    //       </Grid>
    //     </Paper>
    //   );
    // };

    const [responsableOptions, setresponsableOptions] = useState([]);
    useEffect(() => {
        if (!mission._id) return;
        console.log(`mission : ${mission._id}`);
        fetchMissionExperts(setresponsableOptions, mission._id);
    }, [mission]);

    return (
        <Box
            sx={{ width: '100%',
                position: 'relative',
                top: '110px', //* comment this top if you want this navBar to replace the other (older)
                zIndex: '10' }}
        >
            <HeaderBar title={'Tâches'} />
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                >
                    <Tab
                        label="Liste"
                        {...a11yProps(0)}
                    />
                    <Tab
                        label="Tableau"
                        {...a11yProps(1)}
                    />
                    <Tab
                        label="Feuille de route"
                        {...a11yProps(2)}
                    />
                </Tabs>
            </Box>
            <Paper
                elevation={3}
                className="my-3 "
                square={true}
                sx={{ borderRadius: '1.5rem', height: '100%', margin: '10px' }}
            >
                <TabPanel
                    value={value}
                    index={0}
                    className="m-2 "
                >
                    <Grid
                        container
                        justifyContent="flex-end"
                        alignItems="flex-end"
                    >
                        <Grid item>
                            <button
                                onClick={handleOpen}
                                style={{
                                    borderRadius: '4px',
                                    backgroundColor: '#19223F',
                                    color: '#FFFFFF',
                                    border: 'none',
                                    padding: '8px',
                                    fontSize: '13px',
                                }}
                            >
								Nouvelle tâche
                            </button>
                            <button
                                onClick={() => console.log('data\n', data, '\ndata2\n', data2, '\ndata3\n', data3)}
                                style={{
                                    borderRadius: '4px',
                                    backgroundColor: '#19223F',
                                    color: '#FFFFFF',
                                    border: 'none',
                                    padding: '8px',
                                    fontSize: '13px',
                                }}
                            >
								Log Data
                            </button>

                            <AddTaskModal
                                open={open}
                                handleClose={handleClose}
                            />
                        </Grid>
                    </Grid>

                    <TasksList />
                </TabPanel>
                <TabPanel
                    value={value}
                    index={1}
                >
                    <Grid container>
                        <Grid
                            item
                            xs={12}
                        >
                            <Autocomplete
                                onChange={(event, value, reason) => {
                                    if (reason === 'clear') {
                                        //set to defaults
                                        settodocards(tasks.filter((t) => t.status === 'to do'));
                                        setincards(tasks.filter((t) => t.status === 'in progress'));
                                        setdoneCards(tasks.filter((t) => t.status === 'done'));
                                    } else {
                                        //set todotasks
                                        const TODO = tasks
                                            .filter((t) => t.status === 'to do')
                                            .filter((task) =>
                                                task.expertId.map((e) => e._id).includes(value._id)
                                            );

                                        settodocards(TODO);

                                        //set in progress
                                        const inProg = tasks
                                            .filter((t) => t.status === 'in progress')
                                            .filter((task) =>
                                                task.expertId.map((e) => e._id).includes(value._id)
                                            );
                                        setincards(inProg);
                                        // set done
                                        const done = tasks
                                            .filter((t) => t.status === 'done')
                                            .filter((task) =>
                                                task.expertId.map((e) => e._id).includes(value._id)
                                            );
                                        setdoneCards(done);
                                    }
                                }}
                                disablePortal
                                id="combo-box-demo"
                                getOptionLabel={(option) => {
                                    return (
                                        option?.persoData?.nom +
										' ' +
										option?.persoData?.prenom
                                    );
                                }}
                                options={responsableOptions}
                                size="small"
                                sx={{ width: 200, marginRight: '10px' }}
                                renderOption={(props, option) => {
                                    return (
                                        <li
                                            {...props}
                                            key={option._id}
                                        >
                                            {option.persoData?.nom +
												' ' +
												option.persoData?.prenom}
                                        </li>
                                    );
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Responsable"
                                    />
                                )}
                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                        >

                            <Board
                                // data={data}
                                data={data3}
                                // components={{ Card: myCard }}
                                style={{ backgroundColor: '#FFFFFF' }}
                                laneStyle={{
                                    backgroundColor: '#E9ECF1',
                                    borderRadius: '10px',
                                    width: '350px',
                                }}
                                cardStyle={{ backgroundColor: '#FFFFFF' }}
                                onCardMoveAcrossLanes={handleMoveCardAcrossLane}
                            />
                        </Grid>
                    </Grid>
                </TabPanel>
                <TabPanel
                    value={value}
                    index={2}
                >
                    <Cal />
                </TabPanel>
            </Paper>
        </Box>
    );
}